<script>
	export let componente;
	export let parametros; // do componente filho
	export let itens;

	export let flexWrap = true;
</script>

<style>
	.card-grid {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}
</style>

<div class:card-grid="{flexWrap == true}">
	{#each itens as item}
		<svelte:component this={componente} dados={item} parametros={parametros}></svelte:component>
	{:else}
		<p>Carregando...</p>
	{/each}
</div>
